// Action types
export const SET_TRACKING_RECORD = 'SET_TRACKING_RECORD';
export const SET_PARTICIPANT_METADATA = 'SET_PARTICIPANT_METADATA';
export const SET_AVAILABLE_STATUSES = 'SET_AVAILABLE_STATUSES';
export const SET_SUBMISSION_RECORD = 'SET_SUBMISSION_RECORD';
export const UPDATE_TRACKING_RECORD = 'UPDATE_TRACKING_RECORD';

// Initial state
export const initialState = {
    trackingRecord: {},
    participantMetadata: {},
    availableStatuses: [],
    submissionRecord: null
};

// Reducer
export function dataReducer(state, action) {
    switch (action.type) {
        case SET_TRACKING_RECORD:
            return {
                ...state,
                trackingRecord: action.payload
            };
        case SET_PARTICIPANT_METADATA:
            return {
                ...state,
                participantMetadata: action.payload
            };
        case SET_AVAILABLE_STATUSES:
            return {
                ...state,
                availableStatuses: action.payload
            };
        case SET_SUBMISSION_RECORD:
            return {
                ...state,
                submissionRecord: action.payload
            };
        case UPDATE_TRACKING_RECORD:
            return {
                ...state,
                trackingRecord: {
                    ...state.trackingRecord,
                    ...action.payload
                }
            };
        default:
            return state;
    }
} 